import React, { useState, forwardRef } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { clamp } from 'lodash';
import { secondsToHms } from '../../../util';
import PropTypes from 'prop-types';
import Progress from './Progress';

const generateStyles = () => ({
  grid: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  startTime: {
    display: 'none',
    ['@md']: {
      display: 'block'
    }
  },
  startTimeMobile: {
    display: 'block',
    ['@md']: {
      display: 'none'
    }
  }
});

const Slider = forwardRef((props, ref) => {
  const { onHasEnded, audioMeta } = props;
  const [duration, setDuration] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const Grid = UX2.Component.Grid;
  const Cell = Grid.Cell;
  const styles = generateStyles();

  return (
    <Grid gutter={ false } inset={ false } style={ styles.grid }>
      <Cell md={ 1.2 } style={ styles.startTime }>
        <UX2.Element.Details.Minor>{ secondsToHms(currentTime) }</UX2.Element.Details.Minor>
      </Cell>
      <Cell xs={ 12 } md={ 9 }>
        <Progress
          audioMeta={ audioMeta }
          updateDuration={ setDuration }
          handleTimeUpdate={ setCurrentTime }
          onHasEnded={ onHasEnded }
          ref={ ref }
        />
      </Cell>
      <Cell xs={ 6 } md={ 1.2 } style={{ ...styles.startTimeMobile, ...styles.time }}>
        <UX2.Element.Details.Minor style={{ textAlign: 'left' }}>
          { secondsToHms(currentTime) }
        </UX2.Element.Details.Minor>
      </Cell>
      <Cell xs={ 6 } md={ 1.2 }>
        <UX2.Element.Details.Minor style={{ textAlign: 'right' }}>
          { secondsToHms(clamp(0, duration - currentTime, duration)) }
        </UX2.Element.Details.Minor>
      </Cell>
    </Grid>
  );
});

Slider.propTypes = {
  audioMeta: PropTypes.object,
  onHasEnded: PropTypes.func
};

export default Slider;
